import {useEffect} from 'react';
import {useFetchUserPreferencesQuery} from '@api';
import {authSlice} from '@reducers';
import {useAuthenticated, useDispatch} from './common';

export const useUserPreferences = () => {
    const {user, isAuthenticated} = useAuthenticated();
    const dispatch = useDispatch();
    const needsPreferences =
        isAuthenticated && (!user?.preferences || !user.preferences.theme);
    const query = useFetchUserPreferencesQuery(undefined, {
        skip: !needsPreferences,
    });

    useEffect(() => {
        if (query.data && needsPreferences) {
            dispatch(authSlice.actions.updatePreferences(query.data));
        }
    }, [dispatch, needsPreferences, query.data]);

    return {
        preferences: needsPreferences ? query.data : user?.preferences,
        isLoading: needsPreferences && query.isLoading,
        isFetching: needsPreferences && query.isFetching,
        isError: needsPreferences && query.isError,
        refetch: query.refetch,
    };
};
